import config from 'const/config'
import { RootState } from 'redux/store'
import routes from 'const/routes'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { LocationState } from 'types/locationState'
import { getCurrentLanguageFromStorage } from 'helpers'

const useUniversalIdpLink = () => {
  const language = getCurrentLanguageFromStorage()
  const location = useLocation<Partial<LocationState>>()
  const {
    akamaiConfig: { canMigrateUniversalIdp },
    idp: { isIdpFlow }
  } = useSelector((state: RootState) => state)

  const universalIdpRegisterLink = {
    href: `${config.IDP_URL}&ui_locales=${language}&prompt=register`
  }

  const showUniversalLink = isIdpFlow && canMigrateUniversalIdp

  const registerLink = showUniversalLink
    ? universalIdpRegisterLink
    : {
        to: {
          pathname: routes.REGISTER,
          state: { returnTo: routes.HOME, queryParams: location.search },
          search: location.search
        }
      }

  const forgotPasswordLink = showUniversalLink
    ? universalIdpRegisterLink
    : {
        to: {
          pathname: routes.RESET,
          state: { returnTo: routes.HOME, queryParams: location.search },
          search: location.search
        }
      }

  const findUserIdLink = showUniversalLink
    ? universalIdpRegisterLink
    : {
        to: {
          pathname: routes.FIND_USER_ID,
          state: { returnTo: routes.HOME, queryParams: location.search },
          search: location.search
        }
      }

  return { registerLink, forgotPasswordLink, findUserIdLink }
}

export default useUniversalIdpLink
